import React from "react";
import { StyleSheet, View } from "react-native";
import "../../../../App.scss";
import IntroPanel from "../../../../Components/Layout/Default/intro-panel";
const Intro = (props) => {
  return (
    <View style={styles.content}>
      <IntroPanel
        buttonColor="atr"
        header={props.moduleObject.name}
        buttonText="GET STARTED"
        onButtonPress={props.Showing}
      >
        The following ten statements aim to gauge your feeling towards risk.
        {"\n"}
        {"\n"}
        There are no right or wrong answers, choose honestly and we’ll be able
        to pick the investment you’ll feel most comfortable with.
      </IntroPanel>
    </View>
  );
};
export default Intro;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
